// The date stays ISO rather than translateDate so repeated downloads of the same report sort chronologically.
export function getExportFileName(fileNameBase: string) {
    return `${toSafeFileName(fileNameBase)}_${new Date().toISOString().split("T")[0]}.xlsx`;
}

// Names reaching the filename now include entity names, not just view names, and those routinely contain "/"
// (".legal A/S"). The backend interpolates the filename unescaped into the export email's download link and runs it
// through Path.GetFileNameWithoutExtension, both of which treat "/" and "&" as structure, so drop anything that is
// illegal in a filename or would break either of those.
export function toSafeFileName(name: string) {
    return name
        .replace(/[\\/:*?"<>|&#]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}
